import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {UploadService} from '../upload.service';
import {forkJoin} from 'rxjs';
import {FileImportStats} from "../classes/file-import-stats";
import {FileImportTO} from "../../../classes/file-import-to";
import {HttpResponse} from "@angular/common/http";
import {FormTO} from "../../../classes/form-to";

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  @ViewChild('file') file;

  public form: FormTO;

  public files: Set<File> = new Set();

  constructor(public dialogRef: MatDialogRef<DialogComponent>, public uploadService: UploadService) { }

  ngOnInit() {
    // if (this.form) {
      // console.log('ngOnInit.form');
      // console.dir(this.form);
      // alert("Use this form object!!!");
    // }
  }

  importMode = 'upload';
  progress;
  fileImportStatsObservable;
  fileImportStats: FileImportStats;
  canBeClosed = true;
  primaryButtonText = 'Upload';
  showCancelButton = true;
  uploading = false;
  uploadSuccessful = false;
  worksheetIndex: number;
  dialogTitle = 'Upload File';
  uploadMode = true;
  formName: string;

  onFilesAdded() {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        this.files.add(files[key]);
      }
    }
  }

  addFiles() {
    this.file.nativeElement.click();
  }

  runImport() {
    this.primaryButtonText = 'Run Import';
    this.dialogTitle = 'Importing form...';
    this.importMode = 'importForm';

    let formId = 0;

    const fileImportTO: FileImportTO = new FileImportTO();

    if (this.form && this.form.id !== null && this.form.id > 0) {
      formId = this.form.id;
      fileImportTO.formName = this.form.formName;
    } else {
      fileImportTO.formName = this.formName;
    }

    fileImportTO.id = this.fileImportStats.id;
    fileImportTO.worksheetIndex = this.worksheetIndex;
    fileImportTO.formId = formId;

    this.uploadService.import(fileImportTO).subscribe(event => {
      // console.log('runImport.event:');
      // console.dir(event);

      if (event instanceof HttpResponse) {
        const fileImportTO: FileImportTO = <FileImportTO> event.body;
        // console.log('fileImportTO:');
        // console.dir(fileImportTO);
        return this.dialogRef.close(fileImportTO);
      }
    });
  }

  closeDialog() {
    // console.log('%c closeDialog (method)', 'background: #222; color: #bada55');
    // if everything was uploaded already, just close the dialog
    if (this.uploadSuccessful) {
      const fileImportTO = new FileImportTO();
      fileImportTO.id = this.fileImportStats.id;
      fileImportTO.worksheetIndex = this.worksheetIndex;
      return this.dialogRef.close(fileImportTO);
    }

    // set the component state to "uploading"
    this.uploading = true;

    // start the upload and save the progress map
    this.progress = this.uploadService.upload(this.files);

    // convert the progress map into an array
    let allProgressObservables = [];
    for (let key in this.progress) {
      // console.log('closeDialog.key: ' + key);
      // console.dir(this.progress);
      
      
      allProgressObservables.push(this.progress[key].progress);


      this.fileImportStatsObservable = this.progress[key].fileImportStats;

      // console.log('closeDialog.fileImportStats: ');
      // console.dir(this.fileImportStats);
    }

    this.fileImportStatsObservable.subscribe(data => {
      // console.log('fileImportStats 123: ');
      // console.dir(data);
      this.fileImportStats = data as FileImportStats;

      if (this.fileImportStats.contentType && this.fileImportStats.contentType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && this.fileImportStats.worksheets && this.fileImportStats.worksheets.length > 0) {
        this.worksheetIndex = -1;
        this.dialogTitle = 'Pick Worksheet';
        this.uploadMode = false;
        this.importMode = 'pickWorksheet';
      } else {
        const fileImportTO = new FileImportTO();
        fileImportTO.id = this.fileImportStats.id;
        return this.dialogRef.close(fileImportTO);
      }

    });


    // Adjust the state variables

    // The OK-button should have the text "Finish" now
    this.primaryButtonText = 'Run Import';

    // The dialog should not be closed while uploading
    this.canBeClosed = false;
    this.dialogRef.disableClose = true;

    // Hide the cancel-button
    this.showCancelButton = false;

    // When all progress-observables are completed...
    forkJoin(allProgressObservables).subscribe(end => {
      // ... the dialog can be closed again...
      this.canBeClosed = true;
      this.dialogRef.disableClose = false;

      // ... the upload was successful...
      this.uploadSuccessful = true;

      // ... and the component is no longer uploading
      this.uploading = false;
    });
  }

  nameForm() {
    if (this.form && this.form.id !== null && this.form.id > 0) {
      this.runImport();
    } else {
      this.dialogTitle = 'Name Form';
      this.importMode = 'nameForm';
    }
  }
}